export default "__VITE_ASSET__02fa2b11__"